<template>
	<div class="">
        <template v-if="create_payroll_batch === true && autoPayroll !== null" >
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Generate Payroll </h1>
                <button class="btn btn-primary float-right" @click="proceedToTimeOff"> Next</button>
                <button class="btn btn-primary float-right mr-1" @click="cancelAutoGeneratePayroll">Cancel</button>
                <div class="head-date float-right mr-2"> {{autoPayroll_date}} <i class="far fa-clock"></i> </div>
            </div>
            <hr class="border" />
            <div class="alert alert-info" role="alert">
                <p><b> Note! </b> Employees with missing beneficiary details are excluded from the shown listing. </p>
            </div>
            <div class="row normal-ib-space align-items-center mb-3">
                <div class="col-md-3"> <input id="customSearch" type="text" class="form-control search" placeholder="Search employee by name or Wallet Number" title="Search employee by name or Wallet Number" name="" /> </div>
                <div class="col-md-3">
                    <div class="form-group selection-custom-dropdown m-0">
                        <div class="form-control dropdown">
                            <label class="check-holder">
                                <input id="selectAllcheck" type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                            <a class="drop-value-changer" data-offset="0,5" data-toggle="dropdown" href="javascript:void(0)">
                                Select Department <span class="caret"></span>
                            </a>
                            <div class="dropdown-menu">
                                <ul class="list">
                                    <li class="dropdown-item"> <a class="dropdown-link all" href="javascript:void(0)" @click="selectDTRows('All',$event.currentTarget)"> All </a></li>
                                    <li class="dropdown-item" v-for="department in departments" v-bind:key="department.id"> <a class="dropdown-link" href="javascript:void(0)" @click="selectDTRows(department.name, $event.currentTarget)"> {{department.name}} </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="page-status text-right border-bottom-0 p-0">
                        <li class="page-status-list active">
                            <span class="status-highlighter">1</span>
                            Employees
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">2</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Earnings
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Review and Submit
                        </li>
                    </ul>
                </div>
            </div>
            <div class="autogenerate-content">
                <table id="dt-autogenerate-users" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th class="pr-0" style="width: 15px !important"></th>
                            <th style="display: none;"></th>
                            <th>Name</th>
                            <th>Bank</th>
                            <th>AccountNo</th>
                            <th>Employment Status</th>
                            <th>Department</th>
                            <th v-if="alreadyPaid > 0">Already Paid Date</th>
                            <th>Final Settlement</th>
                            <th class="text-center">Gross Salary</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users" v-bind:key="user.id">
                            <td class="pr-0">
                                <input type="checkbox" :id="user.id" :value="user.id">
                            </td>
                            <td style="display: none;">{{user.id}}</td>
                            <td class="">
                                <div class="image-title">
                                    <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                        <img v-if="user.avatar != null" :src="'/avatar/'+user.avatar" alt="" />
                                        <img v-else src="/images/table-dummy-image.jpg" alt="" />
                                    </div>
                                    <div class="ag-employee-part">
                                        <span class="name"> {{user.name}} </span>
                                        <span class="emp-status"> {{user.status}} </span>
                                    </div>
                                </div>
                            </td>
                            <td v-if="user.default_beneficiary != null"> {{user.default_beneficiary.bank_name}} </td>
                            <td v-else>Beneficiary not defined</td>
                            <td v-if="user.default_beneficiary != null"> {{user.default_beneficiary.account_number}} </td>
                            <td v-else>---</td>
                            <td> {{user.employment_status}} </td>
                            <td v-if="user.department != null"> {{user.department.name}} </td>
                            <td v-else> --- </td>
                            <td v-if="alreadyPaid > 0"> --- </td>
                            <td>
                                <label class="check-holder">
                                    <input id="selectAllcheck" type="checkbox" @change="final_settlement(user.id)">
                                    <span class="checkmark"></span>
                                    Yes
                                </label>
                            </td>
                            <td class="text-center"> {{formatAmount(user.net_salary)}} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template v-else-if="create_payroll_batch === null && autoPayroll == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>

<script>
    var dtAutoGenerateTable = null;
    export default {
        data() {
            return {
                userNullSalaries: 0,
                alreadyPaid: 0,
                departments: [],
                create_payroll_batch: null,
                autoPayroll: null,
                autoGenerateUsers: [],
                users: [],
                finalSettlement: [],
                autoPayroll_date: '',
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
					this.getAutoGenerateData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
        methods: {
            getAutoGenerateData(){
                this.$Progress.start();
                axios.get("/api/getAutoPaymentUsers/"+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.users = res.data.users;
                        this.alreadyPaid = res.data.alreadyPaid;
                        this.departments = res.data.departments;
                        this.autoPayroll = res.data.autoPayroll;
                        var date = moment(this.autoPayroll.from_date);
                        this.autoPayroll_date = date.format('MMMM, YYYY');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .then(res => {
                    this.callDataTable();
                    this.$Progress.finish();
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
            callDataTable(){
                var that = this;
                dtAutoGenerateTable = $('#dt-autogenerate-users').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "select": true,
                    "searching":true,
                    "columnDefs": [ {
                        "targets": 0,
                        "orderable": false,
                        "className": 'select-checkbox',
                    } ],
                    select: {
                        style:    'multi',
                        selector: 'td:first-child'
                    },
                    order: [[ 1, "desc" ]],
                });
                $(document).ready(function(){
                    $('#selectAllcheck').on('change', function(){
                        if ($(this).prop('checked')) {
                            $('.list .dropdown-link').addClass('searched');
                            dtAutoGenerateTable.rows().select();
                            $(this).parent().siblings('.drop-value-changer').html("All");
                        }else{
                            $('.list .dropdown-link').removeClass('searched');
                            dtAutoGenerateTable.rows().deselect();
                            $(this).parent().siblings('.drop-value-changer').html("Select Department");
                        }
                    });
                    $('.list a').click(function(event){
                        event.stopPropagation();
                    });
                    $('#customSearch').on( 'keyup', function () {
                        dtAutoGenerateTable.search( this.value ).draw();
                    });
                    dtAutoGenerateTable.on( 'select', function ( e, dt, type, indexes ) {
                        var data = dtAutoGenerateTable.rows('.selected').data();
                        that.autoGenerateUsers = [];
                        for(var i = 0; i < data.length; i++){
                            var user = data[i];
                            var value = user[1];
                            that.autoGenerateUsers.push(value);
                        }
                        var cRow = dtAutoGenerateTable[type](indexes).nodes().to$();
                        $("#btnPaymentTop").show();
                        var tRows = dtAutoGenerateTable.rows().eq(0).length;
                        var totalRow = dtAutoGenerateTable.rows().data().length;
                        var cRowSelected = dtAutoGenerateTable.rows('.selected').data().length;
                        if (cRowSelected == tRows) {
                            $(".selection-custom-dropdown .check-holder input").prop("checked", true);
                        }
                        if (cRowSelected === totalRow) {
                            $(".selection-custom-dropdown .check-holder input").prop("checked", true);
                        }
                    } );
                    dtAutoGenerateTable.on( 'deselect', function ( e, dt, type, indexes ) {
                        var data = dtAutoGenerateTable.rows( indexes ).data();
                        for(var i = 0; i < data.length; i++){
                            var user = data[i];
                            var value = user[1];
                            that.autoGenerateUsers.splice( $.inArray(value,that.autoGenerateUsers), 1);
                        }

                        var cRow  = dtAutoGenerateTable[ type ]( indexes ).nodes().to$();
                        var ele = $(cRow).find(":checkbox");
                        ele.prop('checked', false);
                        var totalRow = dtAutoGenerateTable.rows().data().length;
                        var cRowSelected = dtAutoGenerateTable.rows('.selected').data().length;
                        if (cRowSelected < totalRow) {
                            $(".selection-custom-dropdown .check-holder input").prop("checked",false);
                        }
                        if(cRowSelected == 0){
                            $("#btnPaymentTop").hide();
                        }else{
                            $("#btnPaymentTop").show();
                        }

                    });

                    $('#selectAllcheck').on('change', function(){
                        if ($(this).prop('checked')) {
                            $('.list .dropdown-link').addClass('searched');
                            dtAutoGenerateTable.rows().select();
                            $(this).parent().siblings('.drop-value-changer').html("All");
                        }else{
                            $('.list .dropdown-link').removeClass('searched');
                            dtAutoGenerateTable.rows().deselect();
                            $(this).parent().siblings('.drop-value-changer').html("Select Department");
                        }
                    });
                });
            },
            cancelAutoGeneratePayroll(){
              swal.fire({
                    title: 'Are you sure?',
                    //text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    var id = this.autoPayroll.id;
                    if (result.value) {
                        axios.post('/api/cancelAutoGeneratePayroll', {id})
                            .then(res => {
                                if(res.data.status == '200'){
                                    this.showToastBox('success',res.data.msg);
                                    this.$router.push('/employeePayments');
                                }else{
                                    this.showToastBox('error',res.data.msg);
                                }
                            })
                            .catch(err => {
                                this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
            selectDTRows(txt, obj){
                $("#btnPaymentTop").show();
                var rows = dtAutoGenerateTable.rows({ page: 'current' }).nodes();
                if(txt == "All"){
                    if($(obj).hasClass("searched")){
                        dtAutoGenerateTable.rows().deselect();
                        $(obj).parent().parent().find("a").removeClass("searched");
                        var rows = dtAutoGenerateTable.rows({search: 'applied'}).nodes();
                        $(rows).removeClass("selected");
                        $(obj).removeClass("searched");
                        $(".fa-minus").hide();
                        $(".cstm-chkbx").show();
                        $(".selection-custom-dropdown .check-holder input").prop("checked",false);
                        $("#btnPaymentTop").hide();
                        $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Select Department");
                    }else{
                        $(obj).parent().parent().find("a").removeClass("searched");
                        $(obj).parent().parent().find("a").addClass("searched");
                        var rows = dtAutoGenerateTable.rows({search: 'applied'}).nodes();
                        dtAutoGenerateTable.rows().deselect();
                        dtAutoGenerateTable.rows().select();
                        $(rows).addClass("selected");
                        $(obj).addClass("searched");
                        $(".selection-custom-dropdown .check-holder input").prop("checked",true);
                        $(obj).parent().parent().parent().siblings('.drop-value-changer').html(txt);
                    }
                }else{
                    if($(obj).parent().parent().find(".all").hasClass("searched")){
                        $(obj).parent().parent().find(".all").removeClass("searched");
                    }
                    if($(obj).hasClass("searched")){
                        rows = dtAutoGenerateTable.column(6).search("^"+txt+"$",true,false,true).rows({ 'search': 'applied' });
                        dtAutoGenerateTable.column(6).search('').draw();
                        rows.deselect();
                        $(obj).removeClass("searched");
                        var cText = $(".dropdown-menu li a.searched").html();
                        if(sRowsSearched == 1){
                            $(".fa-minus").show();
                            $(".cstm-chkbx").hide();
                            $(obj).parent().parent().parent().siblings('.drop-value-changer').html(cText);
                        }else if(sRowsSearched == 0){
                            $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Select Department");
                            $(".selection-custom-dropdown .check-holder input").prop("checked",true);

                        }else{
                            $(".selection-custom-dropdown .check-holder input").prop("checked",false);
                            $(".selection-custom-dropdown .drop-value-changer").html("Multiple Selections");
                        }

                    }else{
                        $(".cstm-chkbx").hide();
                        rows = dtAutoGenerateTable.columns(6).search("^"+txt+"$",true,false,true).rows({'search':'applied'});
                        dtAutoGenerateTable.column(6).search('').draw();
                        dtAutoGenerateTable.column(6).search(txt);

                        rows.select();
                        $('input[type="checkbox"]', rows).prop('checked', this.checked);
                        $(rows).addClass("selected");
                        $(obj).addClass("searched");
                        $(".selection-custom-dropdown .check-holder input").prop("checked",false);
                        var sRowsSearched = $(".dropdown-menu li a.searched").length;
                        if(sRowsSearched >1){
                            $(obj).parent().parent().parent().siblings('.drop-value-changer').html("Multiple Selections");
                        }else{
                            var cHTML =$(obj).parent().parent().parent().siblings('.drop-value-changer').html(txt);
                        }
                    }
                }
            },
            proceedToTimeOff(){
                this.$Progress.start();
                if(this.autoGenerateUsers.length == 0)
                {
                    this.showAlertBox('error','You didn\'t select any employee');
                    this.$Progress.fail();
                    return;
                }
                var formData = {
                    payroll_id      : this.autoPayroll.id,
                    users           : this.autoGenerateUsers,
                    finalSettlement : this.finalSettlement
                };
                axios.post('/api/processAutoPayrollUsers', formData)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success',res.data.msg);
                        this.$router.push('/autoPaymentTimeOff/'+res.data.batch_id);
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            final_settlement(addOnId) {
                let index = this.finalSettlement.findIndex(a => a === addOnId)
                if (index >= 0)
                    this.finalSettlement.splice(index, 1)
                else
                    this.finalSettlement.push(addOnId);
            }
        },
        created() {

        },

    }
</script>
